import axios from 'axios';
import { getActiveStoreId } from '../lib/storefront/storeBootstrap.js';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchHeroItems(storeId = getActiveStoreId()) {
    const response = await axios.get(`${API_URL}/api/hero/items`, {
        headers: storeId ? { 'X-Store-Id': storeId } : undefined,
    });
    const items = Array.isArray(response.data) ? response.data : [];
    return items.filter((item) => item?.status !== 'inactive');
}
